import { useEffect } from 'react'
import { captureFromSearch } from './utm'

/**
 * Mount once near the app root: captures UTM params from the current URL into
 * persistent storage so they survive the sign-up auth round-trip (feature
 * "7 Drip"). No-op during SSR / prerender where `window` is undefined.
 */
export function useUtmCapture(): void {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      captureFromSearch(window.location.search)
    }
  }, [])
}
